export const RESET_ACTION = {
  type: 'RESET',
};
export const REFRESH_TOKEN = {
  type: 'REFRESH_TOKEN',
};
